<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-07-14 10:23:40
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:18:39
 * @FilePath: \mrc-base-frontend\src\App.vue
-->
<template>
  <v-app id="app">
    <router-view />
    <!-- 把提示消息放在vuex里面统一配置 -->
    <v-snackbar
      v-model="$store.state.snackbar_open"
      :timeout="$store.state.snackbar_timeout"
      bottom
      center
    >
      {{ $store.state.newsText }}
    </v-snackbar>
    <!-- <v-snackbar :value="true" :timeout="5000">
      <span style="color:#fff">
        这是测试
      </span>
    </v-snackbar> -->
  </v-app>
</template>

<script>
import axios from "axios";
import { filterRouter } from "./utils/filterRouter";
import { btnPermissionList } from "@/service/api/btnPermission";
export default {
  async created() {
  },
  // beforeDestroy() {
  //   alert(123)
  // },
  async mounted() {
    window.onresize = () => {
      this.$store.commit(
        "setCalcHeight",
        document.documentElement.clientHeight - 56 + "px"
      );
    };
    // if (this.$store.state.menuFunctionUuid) {
    //   await this.getBtnPermissionList()
    // }
  },
  methods: {
    async getBtnPermissionList() {
      const res = await btnPermissionList({
        function_uuid: this.$store.state.menuFunctionUuid,
      });
      this.$store.commit("setBtnPermission", res.data ? res.data : []);
    },
  },
  watch: {
    // async '$store.state.menuFunctionUuid' (val) {
    //   if (val && (this.$route.name !== 'reset-password' && this.$route.name !== 'forget-password' && this.$route.name !== 'login')) {
    //     await this.getBtnPermissionList()
    //   }
    // }
  },
  beforeDestroy() {},
};
</script>

<style></style>
